import { useId } from "react";

import { cn } from "@/lib/utils";

export function ClearIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-1.5 w-[7px] text-black", className)}
      viewBox="0 0 7 6"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.801 2.999l-1.64-1.635a.507.507 0 01.006-.695.501.501 0 01.695-.005L3.499 2.3 5.137.663a.498.498 0 01.691.006c.193.19.193.508.006.695L4.2 2.999l1.634 1.637a.498.498 0 01-.005.694M2.8 3l2.992 2.296M2.801 3l-1.64 1.64a.503.503 0 00.006.692M2.801 3l-.94 2.337a.504.504 0 01-.694-.005m4.662 0l-.036-.036m.036.035l-.036-.035m.036.035a.498.498 0 01-.692.007L3.499 3.699m2.294 1.596a.448.448 0 01-.621.006L3.534 3.664l-.035.035m0 0l-.035-.035L1.826 5.3l.036.035L3.499 3.7zM1.167 5.331l.035-.036-.035.036zM3.5 2.371l.035-.035h-.07l.035.036z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
    </svg>
  );
}

export function CloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[25px] text-white", className)}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        height="24"
        rx="12"
        stroke="currentColor"
        width="24"
        x="0.5"
        y="0.5"
      />
      <path
        d="M9.375 9.375l6.25 6.25m.001-6.25l-6.25 6.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function GhostIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-6.5 text-black opacity-10", className)}
      viewBox="0 0 26 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.11 21.82c.968.51 2.096-.402 1.8-1.448-.564-2.04-1.101-4.268-1.37-5.073a1.21 1.21 0 01.645-1.476c1.397-.671 2.955-1.664 3.734-2.201.43-.295.645-.805.564-1.342-.107-.698-.779-1.154-1.477-1.1-.967.08-2.23.16-3.439.214a1.257 1.257 0 01-1.29-1.1c-.375-3.758-1.1-8.24-5.506-8.294-5.05-.053-7.28 4.536-8.06 8.401-.107.59-.67.993-1.289.966-1.047-.053-2.095-.134-2.928-.188-.698-.053-1.37.403-1.477 1.1a1.36 1.36 0 00.564 1.343c.86.59 2.66 1.771 4.164 2.389.403.187.698.563.725 1.02.08 1.073-.215 3.891-.645 6.414-.188 1.1 1.075 1.879 1.988 1.208.699-.51 1.424-.913 1.961-.913 1.666-.027 2.902 2.389 4.836 2.255 1.934-.135 3.089-2.577 4.782-2.658.51-.053 1.1.162 1.718.484zM10.413 8.134c-.618 0-1.129-.832-1.129-1.852s.51-1.852 1.129-1.852c.617 0 1.128.832 1.128 1.852s-.51 1.852-1.128 1.852zm2.256 3.408a1.14 1.14 0 01-1.128-1.154c0-.617.51-1.154 1.128-1.154.618 0 1.128.51 1.128 1.154-.026.644-.51 1.154-1.128 1.154zm2.257-3.408c-.618 0-1.129-.832-1.129-1.852s.51-1.852 1.129-1.852c.617 0 1.128.832 1.128 1.852-.027 1.02-.51 1.852-1.128 1.852z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PumpkinIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-6.5 text-black opacity-10", className)}
      viewBox="0 0 26 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.525-1.816c.201.14.375.312.54.488.205.22.38.492.496.762.4.93.127 1.974-.442 2.791l.696.295a2.035 2.035 0 011.09-.384c.503-.025.956.161 1.188.281a3.56 3.56 0 01.292-.314c-.516-.457-.838-1.07-1.036-1.712-.13-.415-.201-.844-.326-1.26a8.15 8.15 0 00-.26-.748c-.298-.728-.82-1.39-1.735-1.383-.414.003-1.06.211-.975.704.04.226.293.356.471.48z"
        fill="currentColor"
      />
      <path
        d="M24.972 5.935c-.318-.739-1.991-3.136-3.671-3.931-1.68-.795-3.241-.514-4.19-.235 0 0-.793-.148-1.292-.042-.5.105-1.126.425-1.667 1.149 0 0-.57-.375-1.23-.342a1.79 1.79 0 00-1.068.417l-1.157-.491c-.783-.34-2.551-.78-4.154-.715-1.603.065-2.877.788-4.06 1.881C1.303 4.72.46 6.91.098 8.593c-.363 1.683.293 4.713 1.947 6.217 1.653 1.504 2.867 1.884 5.138 1.88 0 0 1.117.68 2.44.88 1.325.202 2.233.079 3.458-.288 0 0 .55.462 1.185.489.634.026 1.201-.338 1.608-.812 0 0 .259.319.954.377.696.058 1.538-.324 1.873-.603 0 0 1.055.255 1.968.03.913-.226 1.428-.658 2.16-1.382.732-.723 2.016-2.545 2.569-4.75.551-2.207-.107-3.958-.425-4.696zM16.79 4.298l2.825 3.204-4.146.574 1.321-3.778zm-7.255.149l1.508 3.745-4.116-.537 2.608-3.208zm9.936 8.957l-1.611-1.582-1.215 1.948-1.43-1.612-1.743 2.022-1.566-1.882-1.88 1.606-1.436-1.487-2.043 1.386-2.642-4.458L6.8 10.85l1.416-1.193 1.849 1.45 1.784-1.519 1.713 1.587 1.424-1.484 1.48 1.297 1.066-1.372 1.3.74 3.12-1.758-2.481 4.805z"
        fill="currentColor"
      />
    </svg>
  );
}

export function RadioIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-5", className)}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill={`url(#${id}a)`} height="8" rx="4" width="8" x="6" y="6" />
      <rect
        height="18"
        rx="9"
        stroke={`url(#${id}b)`}
        strokeWidth="2"
        width="18"
        x="1"
        y="1"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}a`}
          x1="9.988"
          x2="9.988"
          y1="6"
          y2="14"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="9.971"
          x2="9.971"
          y1="0"
          y2="20"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
      </defs>
    </svg>
  );
}
